var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 1.66669C5.39935 1.66669 1.66602 5.40002 1.66602 10C1.66602 14.6 5.39935 18.3334 9.99935 18.3334C14.5993 18.3334 18.3327 14.6 18.3327 10C18.3327 5.40002 14.5993 1.66669 9.99935 1.66669ZM8.33268 14.1667L4.16602 10L5.34102 8.82502L8.33268 11.8084L14.6577 5.48335L15.8327 6.66669L8.33268 14.1667Z",
    fill: "#10B67A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/Check_circle.8edbe0234e3dff9534d92c557dcde4a3.svg";
export { ForwardRef as ReactComponent };